import {Injectable} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Injectable()
export class FileUtilsService {

  constructor(private sanitizer: DomSanitizer) {}

  getImage(content: ImageData): any {
    return this.sanitizer.bypassSecurityTrustUrl('data:image;base64,' + content);
  }

  extractFileName(response: Response): string {
    if (!response || !response.headers.has('content-disposition')) {
      return null;
    }
    const result = response.headers.get('content-disposition').split(';');
    for (const value of result) {
      if (value.trim().startsWith('filename')) {
        return value.split('=')[1].replace(/"/g, '');
      }
    }
    return null;
  }
}
